// extracted by mini-css-extract-plugin
export default {"title":"_3Qjt2","subtitle":"_2qGIo"};